export const StatusPlain = {
    Not: {
        key: 1,
        status: 'not',
        color: '#909399',
        value: '未处理'
    },
    Ing: {
        key: 2,
        status: 'ing',
        color: '',
        value: '核实中'
    },
    Agree: {
        key: 3,
        status: 'agree',
        color: '',
        value: '已采纳'
    },
    Reject: {
        key: 4,
        status: 'fail',
        color: '',
        value: '已拒绝'
    }
}

export const StatusMap = new Map([
    [StatusPlain.Not.key, StatusPlain.Not],
    [StatusPlain.Ing.key, StatusPlain.Ing],
    [StatusPlain.Agree.key, StatusPlain.Agree],
    [StatusPlain.Reject.key, StatusPlain.Reject]
])
